<template>
  <v-layout>
    <v-flex>
      <v-layout wrap align-center>
        <h1 class="headline">Board Basis</h1>
        <v-spacer></v-spacer>
        <v-flex xs12 sm4 class="pb-2">
          <v-text-field
            append-icon="mdi-magnify"
            label="Quick Filter..."
            single-line
            hide-details
            v-model="search"
            class="ma-0"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              fab
              dark
              color="primary"
              @click="createItem"
              class="ma-2"
            >
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Create New Board Basis</span>
        </v-tooltip>
      </v-layout>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="$apollo.loading"
          v-bind="pagingOptions"
          :search="search"
          item-key="node.id"
          fixed-header
          hide-default-footer
        >
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              :hide-view="true"
              @deleteItem="deleteItem($event)"
              @editItem="editItem($event)"
            ></default-list-actions>
          </template>
          <template v-slot:item.notInUse="{ item }">
            <v-simple-checkbox
              v-model="item.node.notInUse"
              disabled
            ></v-simple-checkbox>
          </template>
        </v-data-table>
      </v-card>
      <v-card>
        <v-dialog v-model="boardBasisEditorDialog" persistent width="500">
          <v-card>
            <board-basis-editor
              :boardBasis="selectedBoardBasis"
              :doSaveBoardBasis="doSaveBoardBasis"
              :boardBasisEditorDialog="boardBasisEditorDialog"
              @saved="onSaved($event)"
              @onResetSave="onResetSave"
            ></board-basis-editor>
            <v-card-actions class="grey lighten-4">
              <v-spacer></v-spacer>
              <v-btn color="warning" text @click="closeDialog">Cancel</v-btn>
              <v-btn color="primary" @click="onSaveBoardBasis">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  ALL_BOARD_BASIS_TYPES_SEARCH_QUERY,
  BOARD_BASIS_TYPE_DELETE_MUTATION,
} from "../../../../constants/graphql";
import BoardBasisEditor from "./BoardBasisEditor";
import DefaultListActions from "../../shared/DefaultListActions";
import { pagingOptions } from "../../../../helpers/index";
import SimpleListMixin from "../../../../mixins/SimpleListMixin";
export default {
  name: "BoardBasisTypesList",
  mixins: [SimpleListMixin],
  components: {
    DefaultListActions,
    BoardBasisEditor,
  },

  data() {
    return {
      pagingOptions,
      search: "",
      selectedBoardBasis: {},
      boardBases: {},
      boardBasisEditorDialog: false,
      doSaveBoardBasis: false,
      headers: [
        {
          text: "Name",
          align: "left",
          value: "node.name",
          name: "name",
        },
        {
          text: "Code",
          align: "left",
          value: "node.code",
          name: "name",
        },
        {
          text: "Not In Use",
          align: "left",
          value: "notInUse",
          name: "notInUse",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center",
        },
      ],
    };
  },

  computed: {
    items() {
      return this.boardBases ? this.boardBases.edges : [];
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  methods: {
    createItem() {
      this.selectedBoardBasis = {};
      this.boardBasisEditorDialog = true;
    },
    editItem(item) {
      this.selectedBoardBasis = item.node;
      this.boardBasisEditorDialog = true;
    },
    deleteItem(item) {
      this.$apollo
        .mutate({
          mutation: BOARD_BASIS_TYPE_DELETE_MUTATION,
          variables: {
            boardBasisId: item.node.id,
          },
        })
        .then(this.removeGqlObjectHandler, this.removeGqlObjectErrorHandler);
    },
    removeGqlObjectHandler(result) {
      this.$store.dispatch("showAppSnackbar", {
        msg: "Board basis type removed.",
      });
      if (this.$apollo.queries.boardBases != null) {
        this.$apollo.queries.boardBases.refetch();
      }
    },
    removeGqlObjectErrorHandler(err) {
      this.$store.dispatch("showAppSnackbar", {
        msg: err.graphQLErrors[0].message,
        color: "error",
      });
    },
    onSaved(context) {
      if (this.$apollo.queries.boardBases != null) {
        this.$apollo.queries.boardBases.refetch();
      }
      this.onResetSave();
      this.boardBasisEditorDialog = false;
      this.selectedBoardBasis = {};
      let msg =
        context == "edit"
          ? "Board basis type updated."
          : "Board basis type created.";
      this.$store.dispatch("showAppSnackbar", { msg });
    },
    onResetSave() {
      this.doSaveBoardBasis = false;
    },
    closeDialog() {
      this.boardBasisEditorDialog = false;
      this.selectedBoardBasis = {};
    },
    onSaveBoardBasis() {
      this.doSaveBoardBasis = true;
    },
  },

  apollo: {
    boardBases: {
      query: ALL_BOARD_BASIS_TYPES_SEARCH_QUERY,
      fetchPolicy: "network-only",
      result({ data, loader, networkStatus }) {},
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/admin/service-types/BoardBasisTypesList.vue